export default __webpack_public_path__ + "static/media/Group 4.a87b8ad2.png";